import type { ColDef } from 'ag-grid-community';
import type { FieldValueType } from 'api/tasks';
import type { TaskField } from 'stores/fields';
import { queueMacrotask } from 'utils/macrotask';
import type { PartialValue, TaskUpdateRequest } from '../use-update-tasks';

export const withOnUpdate =
  (
    onUpdate: (request: TaskUpdateRequest[]) => void,
    onCreate: (request: PartialValue[]) => void,
  ) =>
  (columns: ColDef[]): ColDef[] => {
    const onChange = (
      { filtered, task, checkbox, ...record }: Record<string, unknown>,
      field: TaskField,
      from: FieldValueType,
      to: FieldValueType,
      callback?: VoidFunction,
    ) =>
      queueMacrotask(() => {
        if (record.taskId !== 'provisional') {
          onUpdate([{ record, updates: [{ field, from, to }], callback }]);

          return;
        }
        onCreate?.([{ field, to }]);
      });

    return columns.map((col) => ({
      ...col,
      cellEditorParams: col.editable
        ? { ...col.cellEditorParams, onUpdate: onChange }
        : {},
    }));
  };
